export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  detail: (state) => state.detail,
};
